export class Therapist {

    public relations = ['user', 'speciality', 'association'];

    public profile_fields = ['user_id'];


    public names = {
        user_id: function (data) {
            return data.user ? (data.user.f + ' ' + data.user.i + ' '  + data.user.o) : 'пользователь отсутствует';
        },

        speciality_id: function (data) {
            return (data.speciality && data.speciality.name) ;
        },

        association_id: function(data){
            return data.association && data.association.name;
        }
    }
}
